import { apiGet, apiPost } from 'APIPackage/MainModule/common/apiTools';

import { ISegment } from '../interfaces/ISegment';
import { ISession } from '../interfaces/ISession';
import { IUserOrganization } from '../interfaces/IUserOrganization';

export async function fetchEsiaGetOrganizationsByAuthCode(code?: string, state?: string): Promise<IUserOrganization[]> {
  return apiPost<IUserOrganization[]>({
    url: '/esia-authentication-provider/api/esiaauth/getorgs?loaderKey=default',
    body: {
      code,
      state,
    },
    isCredentials: false,
  });
}

export async function fetchEsiaSegmentRegistry(ogrn?: string | null): Promise<ISegment[]> {
  return apiGet<ISegment[]>(`/public/segment-registry/api/segments?attr_key=OGRN&attr_value=${ogrn}`);
}

export async function fetchEsiaSessionByAuthCode(
  code?: string,
  state?: string,
  organisation?: IUserOrganization | null,
  segmentId?: string | null,
  createSegment?: boolean,
): Promise<ISession> {
  return apiPost<ISession>({
    url: '/esia-authentication-provider/api/esiaauth/auth/code',
    body: {
      code,
      state,
      segmentId,
      createSegment,
      organization: organisation,
    },
  });
}

export function fetchEsiaLogout(): void {
  const href = '/esia-authentication-provider/api/esiaauth/logout';

  window.location.href = window.location.origin + href;
}
